{
	"ca": {
		"vots": "% Vot Aliança Catalana en les eleccions catalanes del 2024 (Generalitat)",
		"filtra": "Filtra",
		"tipusDades": [
			{
				"nom": "Mitjana de vot a candidats carlins durant la Restauració (1890 -1923)",
				"key": "carlist_mean",
				"unitat": "%",
				"mapa": true,
				"font": "DEHC"
			},
			{
				"nom": "Pèrdua de vot independentista entre 2017 i 2024 en punts percentuals del cens",
				"key": "indep_collapse",
				"unitat": "%",
				"mapa": true,
				"font": "Generalitat de Catalunya"
			},
			{
				"nom": "Percentatge de població africana",
				"key": "pct_africa",
				"unitat": "%",
				"mapa": true,
				"font": "IDESCAT (2022)"
			},
			{
				"nom": "Percentatge de població estrangera",
				"key": "pct_estrangers",
				"unitat": "%",
				"mapa": true,
				"font": "INE (2025)"
			},
			{
				"nom": "% Població que són estrangers provinents de països amb renda baixa",
				"key": "pct_estrangers_renda_baixa",
				"unitat": "%",
				"mapa": true,
				"font": "IDESCAT (2023)"
			},
			{ "nom": "Índex Socioeconòmic", "key": "ist", "unitat": "", "mapa": true, "font": "IDESCAT (2023)" },
			{ "nom": "% Població ocupada", "key": "pct_ocupat", "unitat": "%", "mapa": true, "font": "IDESCAT (2023)" },
			{
				"nom": "% Població amb estudis superiors",
				"key": "pct_edu_superior",
				"unitat": "%",
				"mapa": true,
				"font": "IDESCAT (2023)"
			},
			{
				"nom": "% Població de més de 65 anys",
				"key": "pct_65plus",
				"unitat": "%",
				"mapa": true,
				"font": "IDESCAT (2023)"
			},
			{
				"nom": "Renda neta per persona",
				"key": "renda_neta_persona",
				"unitat": " €",
				"mapa": true,
				"font": "INE (2023)"
			},
			{
				"nom": "Mesquites per cada 1.000 habitants",
				"key": "mesquites_per_mil",
				"unitat": "‱",
				"mapa": true,
				"font": "Generalitat (2024)"
			},
			{
				"nom": "Nombre d’explotacions porcines per cada 1.000 habitants",
				"key": "porci_per_mil",
				"unitat": "‱",
				"mapa": true,
				"font": "DARP (2026)"
			},
			{ "nom": "Població", "key": "poblacio", "unitat": " hab.", "mapa": true, "font": "IDESCAT (2024)" }
		],
		"font": "Font:",
		"mapbox": {
			"FullscreenControl.Enter": "Pantalla completa",
			"FullscreenControl.Exit": "Torna",
			"ScrollZoomBlocker.CmdMessage": "Fes ⌘ + scroll per fer zoom al mapa",
			"ScrollZoomBlocker.CtrlMessage": "Fes ctrl + scroll per fer zoom al mapa"
		}
	},
	"es": {
		"vots": "% Voto Aliança en las elecciones catalanas del 2024 (Generalitat)",
		"filtra": "Filtra",
		"tipusDades": [
			{
				"nom": "Media de votos a candidatos carlistas durante la Restauración (1875-1923)",
				"key": "carlist_mean",
				"unitat": "%",
				"mapa": true,
				"font": "DEHC"
			},
			{
				"nom": "Pérdida de voto independentista entre 2017 y 2024 en puntos porcentuales del censo",
				"key": "indep_collapse",
				"unitat": "%",
				"mapa": true,
				"font": "Generalitat de Cataluña"
			},
			{
				"nom": "Porcentaje de población africana",
				"key": "pct_africa",
				"unitat": "%",
				"mapa": true,
				"font": "IDESCAT (2022)"
			},
			{
				"nom": "% Población que son extranjeros procedentes de países con renta baja",
				"key": "pct_estrangers_renda_baixa",
				"unitat": "%",
				"mapa": true,
				"font": "IDESCAT (2023)"
			},
			{ "nom": "Índice Socioeconómico", "key": "ist", "unitat": "", "mapa": true, "font": "IDESCAT (2023)" },
			{
				"nom": "% Población ocupada",
				"key": "pct_ocupat",
				"unitat": "%",
				"mapa": true,
				"font": "IDESCAT (2023)"
			},
			{
				"nom": "% Población con estudios superiores",
				"key": "pct_edu_superior",
				"unitat": "%",
				"mapa": true,
				"font": "IDESCAT (2023)"
			},
			{
				"nom": "% Población de más de 65 años",
				"key": "pct_65plus",
				"unitat": "%",
				"mapa": true,
				"font": "IDESCAT (2023)"
			},
			{
				"nom": "Renta neta por persona",
				"key": "renda_neta_persona",
				"unitat": " €",
				"mapa": true,
				"font": "INE (2023)"
			},
			{
				"nom": "Mezquitas por cada 1.000 habitantes",
				"key": "mesquites_per_mil",
				"unitat": "‱",
				"mapa": true,
				"font": "Generalitat de Cataluña (2024)"
			},
			{
				"nom": "Número de explotaciones porcinas por cada 1.000 habitantes",
				"key": "porci_per_mil",
				"unitat": "‱",
				"mapa": true,
				"font": "DARP (2026)"
			},
			{ "nom": "Población", "key": "poblacio", "unitat": " hab.", "mapa": true, "font": "IDESCAT (2024)" }
		],
		"font": "Fuente:",
		"mapbox": {
			"FullscreenControl.Enter": "Pantalla completa",
			"FullscreenControl.Exit": "Vuelve",
			"ScrollZoomBlocker.CmdMessage": "Usa ⌘ + scroll para hacer zoom en el mapa",
			"ScrollZoomBlocker.CtrlMessage": "Usa ctrl + scroll para hacer zoom en el mapa"
		}
	}
}
